import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ConfirmProvider } from "./components/ConfirmDialog";
import MapPlanner from "./components/MapPlanner";
import ActivityLog from "./components/ActivityLog";

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/log" element={<ActivityLog />} />
            <Route path="*" element={<MapPlanner />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
